import React, { Component } from "react";
import {
  Wrapper,
  CardBody,
  Card,
  Title,
  Copy,
  Bold,
  Row
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import { loadPlans, renderPrice, openUrl } from "app/NativeActions";
import PlanFeature from "./PlanFeature";
import { store } from "app/store";

class Plan extends Component {
  constructor(props) {
    super(props);

    this.state = {
      plan: null,
      loading: true
    };
  }

  componentDidMount() {
    if (this.props.plan_slug) {
      this.getData(this.props.plan_slug);
    }
  }

  getData(slug) {
    loadPlans(slug)
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          this.setState({ plan: data.items[0] });
        }
        this.setState({ loading: false });
      })
      .catch(err => {
        this.setState({ loading: false });
      });
  }

  renderPricing(plan) {
    const device = store.getState().native.device;
    const colors = store.getState().settings.colors;

    return (
      <Wrapper
        style={{
          padding: 20,
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Copy
          style={{
            fontSize: 12,
            color: colors.light_text_color,
            textAlign: "center"
          }}
        >
          {this.props.selected_frequency == "annually" &&
          !plan.fields.annualOnly &&
          !plan.fields.monthlyOnly ? (
            <Copy
              style={{
                fontSize: 12,
                color: colors.light_text_color,
                textAlign: "center"
              }}
            >
              Starts at{" "}
              <Copy
                style={{
                  textDecorationLine: "line-through",
                  textDecorationStyle: "solid",
                  display: device == "desktop" ? "inline" : "none"
                }}
              >
                {renderPrice(plan.fields.monthlyPriceCents, "no_decimal")}
              </Copy>
            </Copy>
          ) : (
            "Starts at"
          )}
        </Copy>
        <Wrapper>
          <Title
            style={{
              textAlign: "center",
              fontSize: 32,
              color: colors.active_color,
              marginBottom: 10
            }}
          >
            {plan.fields.annualOnly
              ? renderPrice(plan.fields.yearlyPriceCents, "no_decimal") + "/yr"
              : plan.fields.monthlyOnly
              ? renderPrice(plan.fields.monthlyPriceCents, "no_decimal") + "/mo"
              : this.props.selected_frequency == "annually"
              ? renderPrice(plan.fields.yearlyPriceCents / 12, "no_decimal") +
                "/mo"
              : renderPrice(plan.fields.monthlyPriceCents, "no_decimal") +
                "/mo"}
          </Title>
        </Wrapper>

        <Copy
          style={{
            fontSize: 12,
            color: colors.light_text_color,
            textAlign: "center"
          }}
        >
          {plan.fields.annualOnly ? (
            "billed yearly"
          ) : this.props.selected_frequency == "annually" &&
            !plan.fields.monthlyOnly ? (
            <Copy
              style={{
                fontSize: 12,
                color: colors.light_text_color,
                textAlign: "center"
              }}
            >
              billed at{" "}
              <Copy
                style={{
                  textDecorationLine: "line-through",
                  textDecorationStyle: "solid",
                  display: device == "desktop" ? "inline" : "none"
                }}
              >
                {renderPrice(plan.fields.monthlyPriceCents * 12, "no_decimal")}
              </Copy>{" "}
              <Bold>
                {renderPrice(plan.fields.yearlyPriceCents, "no_decimal")}
              </Bold>{" "}
              annually
            </Copy>
          ) : (
            "billed monthly"
          )}
        </Copy>

        {!!plan.fields.extraText ? (
          <Copy
            style={{
              fontSize: 12,
              color: colors.light_text_color,
              textAlign: "center"
            }}
          >
            {plan.fields.extraText}
          </Copy>
        ) : null}
        {!this.props.exclude_select_button ? (
          <Row style={{ justifyContent: "center" }}>
            <PillButton
              onPress={() => {
                if (!!plan.fields.buttonType) {
                  switch (plan.fields.buttonType) {
                    case "link":
                      openUrl(plan.fields.buttonLink);
                      break;
                    default:
                      break;
                  }
                } else {
                  this.props.onEngineSelect({
                    engine: this.props.engine_slug,
                    tier: plan.fields.tier,
                    frequency: this.props.selected_frequency
                  });
                }
              }}
              primary={true}
            >
              {plan.fields.buttonText ? plan.fields.buttonText : "Select Plan"}
            </PillButton>

            {plan.fields.secondaryButtonText ? (
              <PillButton
                onPress={() => {
                  switch (plan.fields.secondaryButtonType) {
                    default:
                    case "link":
                      openUrl(plan.fields.secondaryButtonLink);
                      break;

                    case "training":
                      this.props.onDemoPress({
                        title: plan.fields.secondaryButtonText,
                        webinar_id: plan.fields.secondaryButtonLink
                      });
                      break;
                  }
                }}
                style={{ marginLeft: 0 }}
                primary={false}
              >
                {plan.fields.secondaryButtonText}
              </PillButton>
            ) : null}
          </Row>
        ) : null}
      </Wrapper>
    );
  }

  render() {
    const { plan } = this.state;
    const colors = store.getState().settings.colors;
    if (plan) {
      return (
        <Wrapper
          style={{
            flex: 1,
            alignSelf: "stretch",
            maxWidth: 450,
            minWidth: 300
          }}
        >
          <Card style={{ padding: 20 }}>
            {!!plan.fields.planTitle ? (
              <Wrapper
                style={{
                  marginBottom: 10,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Title>
                  {this.props.full_title
                    ? plan.fields.title
                    : plan.fields.planTitle}
                </Title>
              </Wrapper>
            ) : null}
            {this.renderPricing(plan)}
            <Wrapper>
              {plan.fields.features &&
                plan.fields.features.map((feature, i) => {
                  return (
                    <PlanFeature key={i} feature={feature} colors={colors} />
                  );
                })}
            </Wrapper>
          </Card>
        </Wrapper>
      );
    }

    return null;
  }
}

export default Plan;
